import { NavigationRouteContext } from '@react-navigation/native';
import { NewContent } from 'app/screens/new';
import { View } from 'react-native';
import { styles } from '../components';

import type { OfferHubState } from '../hooks';

export function OfferHubManualTab({
  tab,
  manualRoute,
  creationRequest,
  navigation,
  setActive,
  setTab,
  centralizedCreation,
}: Pick<
  OfferHubState,
  'tab' | 'manualRoute' | 'creationRequest' | 'navigation' | 'setActive' | 'setTab' | 'centralizedCreation'
>) {
  return (
    <View
      style={[styles.flex, tab !== 'manual' && { display: 'none' }]}
      accessibilityElementsHidden={tab !== 'manual'}
      importantForAccessibility={tab !== 'manual' ? 'no-hide-descendants' : 'auto'}
    >
      <NavigationRouteContext.Provider value={manualRoute}>
        <NewContent
          navigation={navigation}
          route={manualRoute}
          creationRequest={creationRequest}
          embedded
          centralizedCreation={centralizedCreation}
          onRequestFocus={() => {
            setActive(false);
            setTab('manual');
          }}
        />
      </NavigationRouteContext.Provider>
    </View>
  );
}
